export default __webpack_public_path__ + "static/2.2_FR-51a242058784585b3baa6ddae4b26e66.webp";